<nb-card>
    <nb-card-header>Create content for {{stepperTitle}}
        <nb-actions>
            <nb-action (click)="closeDialog()">
                <nb-icon icon="close-outline" pack="eva" title="Close Dialog"></nb-icon>
            </nb-action>
        </nb-actions>
    </nb-card-header>
        <nb-card-body>
            <ng-container [ngSwitch]="stepperTitle">
                    <ng-container *ngSwitchCase="'Banner'">
                        <nb-stepper orientation="horizontal" (stepChange)="onStepChange($event)" disableStepNavigation>
                            <nb-step [label]="linkType">
                                <ng-template #linkType>Add Background Image</ng-template>
                                <div class="step-content-wrapper">
                                    <div class="stepper-actions">
                                        <nb-actions size="small">
                                            <nb-action>Load Background Image</nb-action>
                                            <nb-action title="Background Image"
                                                class="popover-icon"
                                                (click)="imageDialog()">
                                                <nb-icon icon="image-outline" pack="eva" title="Edit Image"></nb-icon>
                                                <!-- <svg viewBox="0 0 24 24" id="ic_insert_photo_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                                    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
                                                </svg> -->
                                            </nb-action>
                                        </nb-actions>
                                    </div>
                                    <div class="preview-content" [attr.id]="cell.cellId">
                                        <div class="image-container">
                                            <img 
                                              [src]="imgSrc"
                                              (error)="onImageError()"
                                              alt="Image placeholder"
                                              *ngIf="!showPlaceholder"
                                            />
                                            <ng-container *ngIf="showPlaceholder">
                                                <svg 
                                                    width="100%" 
                                                    height="100%" 
                                                    xmlns="http://www.w3.org/2000/svg" 
                                                    class="placeholder">
                                                    <rect width="100%" height="100%" fill="#e0e0e0" />
                                                    <text x="50%" y="50%" font-size="16" fill="#333" text-anchor="middle" dy=".3em">Image goes here</text>
                                                  </svg>
                                                  
                                              <!-- <svg 
                                                width="100" 
                                                height="100" 
                                                viewBox="0 0 24 24" 
                                                xmlns="http://www.w3.org/2000/svg" 
                                                class="placeholder"
                                              >
                                                <circle cx="12" cy="12" r="10" stroke="grey" stroke-width="2" fill="lightgrey"/>
                                                <text x="50%" y="50%" text-anchor="middle" fill="grey" font-size="8" dy=".3em">No Image</text>
                                              </svg> -->
                                            </ng-container>
                                          </div>
                                          
                                    </div>
                                    <div class="button-wrapper">
                                        <button nbButton disabled nbStepperNext size="small" class="btn-right">prev</button>
                                        <button nbButton nbStepperNext size="small">next</button>
                                    </div>
                                </div>
                            </nb-step>
                            <nb-step *ngFor="let contentElement of contentElements" 
                                [label]="getEnumValue(contentElement)">
                                <!-- <ng-template #cntElEnum>
                                    <div *ngIf="contentElement | transformContentElementEnum:'contentElementEnum':getEnumValue as transFormedCntEl">{{cntElementEnum[transFormedCntEl.contentElementEnum]}}</div>
                                </ng-template> -->
                                <!-- <ng-template #cntElEnum *ngIf="contentElement | transformContentElementEnum:'contentElementEnum':getEnumValue as transFormedCntEl">{{cntElementEnum[transFormedCntEl.contentElementEnum]}}</ng-template> -->
                                <div class="step-content-wrapper">
                                    <ng-container [ngSwitch]="contentElement.contentElementEnum">
                                        <ng-container *ngSwitchCase="'header'">
                                            <div class="preview-content">
                                                <div class="h6">Header</div>  
                                                <p>Capture attention with a strong, concise statement that highlights the core value or main message.</p>
                                                <input nbInput type="text" fieldSize="medium" [ngModel]="contentElement.text" (ngModelChange)="onChangeContentEl(contentElement.elId,$event)"/>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'text'">
                                            <div class="preview-content">
                                                <div class="h6">Short Text</div> 
                                                <p>A brief description or summary that expands on the subheader, emphasizing key benefits or details to engage the viewer.</p>
                                                <input nbInput type="text" fieldSize="medium" [ngModel]="contentElement.text" (ngModelChange)="onChangeContentEl(contentElement.elId,$event)"/>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'action'">
                                            <div class="preview-content">
                                                <div class="h6">Call to Action Button</div>  
                                                <p>An action-oriented phrase that encourages the viewer to take the next step, such as 'Learn More,' 'Get Started,' or 'Shop Now.</p> 
                                            </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'sub-header'">
                                            <div class="preview-content">
                                                <div class="h6">Subheader</div>
                                                <p>A secondary line that adds detail or context to the header, supporting the main message and providing more insight.</p>
                                                <input nbInput type="text" fieldSize="medium" [ngModel]="contentElement.text" (ngModelChange)="onChangeContentEl(contentElement.elId,$event)"/>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                    <div class="button-wrapper">
                                        <button nbButton [disabled]="firstStep" nbStepperPrevious size="small" class="btn-right">prev</button>
                                        <button nbButton nbStepperNext size="small">next</button>
                                        <button nbButton size="small" status="primary" (click)="onSubmitContent()" [disabled]="!lastStep">Done<nb-icon icon="checkmark-outline" pack="eva" status="success"></nb-icon></button>
                                    </div>
                                </div>
                            </nb-step>
                            <!-- <nb-step [label]="contentId">
                                <ng-template #contentId>Content ID</ng-template>
                                <div class="step-content-wrapper">
                                    <div class="step-content-inner">
                                        <div class="step-info">Content ID #2</div>
                                        <div>
                                            <input nbInput type="text" fieldSize="medium" [value]="cellId"/>
                                        </div>
                                        <div class="button-wrapper">
                                            <button nbButton nbStepperNext size="small">prev</button>
                                            <button nbButton nbStepperNext size="small">next</button>
                                        </div>
                                    </div>
                                </div> 
                            </nb-step> -->
                            <!-- <nb-step [label]="bannerTextEditor">
                                <ng-template #bannerTextEditor>Text</ng-template>
                                <div class="step-content-wrapper">
                                    <div class="step-content-inner banner-text">
                                        <div *ngFor="let contentElement of contentElements" class="editor-input-group">
                                            <div class="step-info">{{contentElement.name}}</div>
                                            <ng-container *ngIf="contentElement.inputType && contentElement.inputType == 'textarea';else genInput">
                                                <textarea nbInput fullWidth placeholder="Textarea" [value]="contentElement.text"></textarea>
                                            </ng-container>
                                            <ng-template #genInput>
                                                <input nbInput type="text" fieldSize="medium" [ngModel]="contentElement.text" (ngModelChange)="onChangeContentEl(contentElement.name,$event)"/>
                                            </ng-template>
                                            
                                        </div>
                                        <div class="button-wrapper">
                                            <button nbButton nbStepperNext size="small">prev</button>
                                            <button nbButton disabled nbStepperNext size="small">next</button>
                                        </div>
                                    </div>
                                </div>
                            </nb-step>  -->
                        </nb-stepper>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Link'">
                        <kve-productlink-cell-stepper [cell]="cell" [section]="section" (closeHostDialog)="closeDialog($event)"></kve-productlink-cell-stepper>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Call To Action'">
                        <kve-call-to-action-cell-stepper [cell]="cell" [section]="section" (closeHostDialog)="closeDialog($event)"></kve-call-to-action-cell-stepper>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Blog Article Link'">
                        <kve-blog-article-link-stepper [cell]="cell" [section]="section" (closeHostDialog)="closeDialog($event)"></kve-blog-article-link-stepper>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Cell'">
                        <kve-product-cell-stepper [cell]="cell" [section]="section" (closeHostDialog)="closeDialog($event)"></kve-product-cell-stepper>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Feature'">
                        <kve-feature-cell-stepper [cell]="cell" [section]="section" (closeHostDialog)="closeDialog($event)"></kve-feature-cell-stepper>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Testimonial'">
                        <kve-testimonial-cell-stepper [cell]="cell" [section]="section" (closeHostDialog)="closeDialog($event)"></kve-testimonial-cell-stepper>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Hero Image'">
                        <kve-hero-image-cell-stepper [cell]="cell" [section]="section" (closeHostDialog)="closeDialog($event)"></kve-hero-image-cell-stepper>
                    </ng-container>
            </ng-container>
        </nb-card-body>
</nb-card>
